import Main from '@/views/Main.vue';

// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
    path: '/login',
    name: 'login',
    meta: {
        title: '登录 - Go-DP前后端分离开发平台 '
    },
    component: () => import('@/views/login.vue')
};

export const registRouter = {
    path: '/regist',
    name: 'regist',
    meta: {
        title: '注册 - Go-DP前后端分离开发平台'
    },
    component: () => import('@/views/regist.vue')
};

export const registResult = {
    path: '/regist-result',
    name: 'regist-result',
    meta: {
        title: '注册结果 - Go-DP前后端分离开发平台'
    },
    component: () => import('@/views/regist-result.vue')
};

export const reset = {
    path: '/reset',
    name: 'reset',
    meta: {
        title: '重置密码 - Go-DP前后端分离开发平台'
    },
    component: () => import('@/views/reset.vue')
};

export const relateRouter = {
    path: '/relate',
    name: 'relate',
    meta: {
        title: '绑定账号 - Go-DP前后端分离开发平台 '
    },
    component: () => import('@/views/relate.vue')
};

export const authorizeRouter = {
    path: '/authorize',
    name: 'authorize',
    meta: {
        title: 'Go-DP统一认证平台 - Go-DP前后端分离开发平台 '
    },
    component: () => import('@/views/authorize.vue')
};

// export const page404 = {
//     path: '/*',
//     name: 'error-404',
//     meta: {
//         title: '404-页面不存在'
//     },
//     component: () => import('@/views/error-page/404.vue')
// };

export const page403 = {
    path: '/403',
    meta: {
        title: '403-权限不足'
    },
    name: 'error-403',
    component: () => import('@/views/error-page/403.vue')
};

export const page500 = {
    path: '/500',
    meta: {
        title: '500-服务端错误'
    },
    name: 'error-500',
    component: () => import('@/views/error-page/500.vue')
};

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
    path: '/',
    name: 'otherRouter',
    redirect: '/home',
    component: Main,
    children: [
        { path: 'home', title: { i18n: 'home' }, name: 'home_index', component: () => import('@/views/home/home.vue') },
        { path: 'ownspace', title: '个人中心', name: 'ownspace_index', component: () => import('@/views/own-space/own-space.vue') },
        { path: 'message', title: '消息中心', name: 'message_index', component: () => import('@/views/message/message.vue') },
        { path: 'add', title: '添加', name: 'add', component: () => import('@/views/xboot-vue-template/new-window/add.vue') },
        { path: 'edit', title: '编辑', name: 'edit', component: () => import('@/views/xboot-vue-template/new-window/edit.vue') },
        { path: 'leave', title: '请假申请', name: 'leave', component: () => import('@/views/activiti/business/leave.vue') },
        { path: 'historic-detail', title: '流程进度历史详情', name: 'historic_detail', component: () => import('@/views/activiti/historic-detail/historicDetail.vue') },   
        { path: 'gql-demo', title: '投放链接管理', name: 'gql_demo', component: () => import('@/views/graphql/demo.vue') },
        { path: 'personal-progress', title: '救助进度', name: 'personal-progress', component: () => import('@/views/redcode/personal_progress/index.vue') },
        { path: 'charity-usefulness', title: '善款去向', name: 'charity-usefulness', component: () => import('@/views/redcode/charity_usefulness/index.vue') },
        { path: 'project-progress', title: '项目进度', name: 'project-progress', component: () => import('@/views/redcode/project_progress/index.vue') },
        { path: 'enterprise-charge', title: '企业充值', name: 'enterprise-charge', component: () => import('@/views/redcode/enterprise_charge/index.vue') },
        { path: 'enterprise-product', title: '企业商品管理', name: 'enterprise-product', component: () => import('@/views/redcode/enterprise_product/index.vue') },
        { path: 'purchase-record', title: '扫码记录', name: 'purchase-record', component: () => import('@/views/redcode/purchase_record/index.vue') },
        { path: 'donation-record', title: '捐赠记录', name: 'donation-record', component: () => import('@/views/redcode/donation_record/index.vue') },
        { path: 'banner', title: '轮播图管理', name: 'banner', component: () => import('@/views/redcode/banner/index.vue') },
        
    ]
};

export const appRouter = [];

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
    loginRouter,
    registRouter,
    registResult,
    reset,
    relateRouter,
    authorizeRouter,
    otherRouter,
    ...appRouter,
    page500,
    page403
];
